import { render, staticRenderFns } from "./periods.vue?vue&type=template&id=09055eb0&scoped=true&"
import script from "./periods.vue?vue&type=script&lang=js&"
export * from "./periods.vue?vue&type=script&lang=js&"
import style0 from "./periods.vue?vue&type=style&index=0&id=09055eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09055eb0",
  null
  
)

export default component.exports